import { put, call, takeEvery } from "redux-saga/effects";
import { safe } from "providers/GeneralProvider/saga";
import {
  getTravelTypeListRequest,
  getTravelTypeListSuccess,
  getTravelTypeListFailure,
  getTravelTypeAllRequest,
  getTravelTypeAllSuccess,
  getTravelTypeAllFailure,
  createTravelTypeRequest,
  createTravelTypeSuccess,
  createTravelTypeFailure,
  updateTravelTypeRequest,
  updateTravelTypeSuccess,
  updateTravelTypeFailure,
  deleteTravelTypeRequest,
  deleteTravelTypeSuccess,
  deleteTravelTypeFailure,
  restoreTravelTypeRequest,
  restoreTravelTypeSuccess,
  restoreTravelTypeFailure,
} from "./slice";
import request from "utils/api";
import Helper from "utils/helpers";

function* getTravelTypeList({ meta, payload }) {
  try {
    const params = {
      page: payload?.page || 1,
      limit: payload?.limit || 100,
      isDeleted: false,
    };

    const { data } = yield call(request, "api/travel/type", params, {
      method: "GET",
    });

    yield put(getTravelTypeListSuccess(data, meta));
  } catch (error) {
    yield put(getTravelTypeListFailure(error.message, meta));
  }
}

function* getTravelTypeAll({ meta }) {
  try {
    const { data } = yield call(request, "api/travel/type-all", {}, {
      method: "GET",
    });

    yield put(getTravelTypeAllSuccess(data, meta));
  } catch (error) {
    yield put(getTravelTypeAllFailure(error.message, meta));
  }
}

function* createTravelType({ meta, payload }) {
  try {
    const { data } = yield call(request, "api/travel/type", payload, {
      method: "POST",
    });

    yield put(createTravelTypeSuccess(data, meta));
    Helper.toastr("Thành công", "Đã tạo loại du lịch mới", "success");
  } catch (error) {
    yield put(createTravelTypeFailure(error.message, meta));
    Helper.toastr("Lỗi", "Không thể tạo loại du lịch", "error");
  }
}

function* updateTravelType({ meta, payload }) {
  try {
    const { _id, ...updateData } = payload;
    const { data } = yield call(request, `api/travel/type/${_id}`, updateData, {
      method: "PUT",
    });

    yield put(updateTravelTypeSuccess(data, meta));
    Helper.toastr("Thành công", "Đã cập nhật loại du lịch", "success");
  } catch (error) {
    yield put(updateTravelTypeFailure(error.message, meta));
    Helper.toastr("Lỗi", "Không thể cập nhật loại du lịch", "error");
  }
}

function* deleteTravelType({ meta, payload }) {
  try {
    yield call(request, `api/travel/type/${payload._id}`, {}, {
      method: "DELETE",
    });

    yield put(deleteTravelTypeSuccess({}, meta));
    Helper.toastr("Thành công", "Đã xóa loại du lịch", "success");
  } catch (error) {
    yield put(deleteTravelTypeFailure(error.message, meta));
    Helper.toastr("Lỗi", "Không thể xóa loại du lịch", "error");
  }
}

function* restoreTravelType({ meta, payload }) {
  try {
    const { data } = yield call(request, `api/travel/type/${payload._id}/restore`, {}, {
      method: "PUT",
    });

    yield put(restoreTravelTypeSuccess(data, meta));
    Helper.toastr("Thành công", "Đã khôi phục loại du lịch", "success");
  } catch (error) {
    yield put(restoreTravelTypeFailure(error.message, meta));
    Helper.toastr("Lỗi", "Không thể khôi phục loại du lịch", "error");
  }
}

function* travelTypeSaga() {
  yield takeEvery(getTravelTypeListRequest.type, safe(getTravelTypeList));
  yield takeEvery(getTravelTypeAllRequest.type, safe(getTravelTypeAll));
  yield takeEvery(createTravelTypeRequest.type, safe(createTravelType));
  yield takeEvery(updateTravelTypeRequest.type, safe(updateTravelType));
  yield takeEvery(deleteTravelTypeRequest.type, safe(deleteTravelType));
  yield takeEvery(restoreTravelTypeRequest.type, safe(restoreTravelType));
}

export default travelTypeSaga;